import * as pdfjsLib from 'pdfjs-dist';

// Set worker source
// For pdfjs-dist v5+, the worker is an ES module (.mjs)
// We use unpkg to get the matching version
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjsLib.version}/build/pdf.worker.min.mjs`;

export const convertPdfToImages = async (file: File): Promise<File[]> => {
  const arrayBuffer = await file.arrayBuffer();
  
  // Use try-catch for loading document
  try {
    const loadingTask = pdfjsLib.getDocument({ data: arrayBuffer });
    const pdf = await loadingTask.promise;
    const pageCount = pdf.numPages;
    const imageFiles: File[] = [];

    for (let i = 1; i <= pageCount; i++) {
      const page = await pdf.getPage(i);
      
      // Calculate scale to fit a reasonable width (e.g. 1024px) or just use a fixed scale
      // Higher scale = better quality for OCR/Extraction
      const scale = 2.0; 
      const viewport = page.getViewport({ scale });

      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      if (!context) {
        throw new Error('Could not get canvas context');
      }

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport: viewport,
        canvas,
      };

      await page.render(renderContext).promise;

      const blob = await new Promise<Blob | null>((resolve) => {
        canvas.toBlob(resolve, 'image/jpeg', 0.8);
      });

      if (blob) {
        // Create a file name that indicates page number
        const baseName = file.name.replace(/\.[^/.]+$/, "");
        const imageName = `${baseName}_page_${i}.jpg`;
        const imageFile = new File([blob], imageName, { type: 'image/jpeg' });
        imageFiles.push(imageFile);
      }
    }

    return imageFiles;
  } catch (error) {
    console.error('Error in convertPdfToImages:', error);
    throw error;
  }
};
